import React from "react";
import PageShell from "./PageShell";
import KpiBar from "./KpiBar";
import { PageHeader } from "../index";

/**
 * Template A — Dashboard (PDR §6.A)
 * ─────────────────────────────────
 * Purpose : pages that SUMMARIZE state (Overview · Growth · Digest).
 * Slots   : header, kpis (4-5), charts row, section header, optional table.
 *
 * Composition order is fixed. Consumers may omit any slot except header.
 */
export default function TemplateDashboard({
  header,       // <PageHeader ... />
  kpis,         // { items: [...], cols?: 4|5 } | ReactNode
  charts,       // ReactNode (typically a 2-up grid of Cards)
  section,      // <PageSection ... /> — optional divider before a drill-down
  table,        // ReactNode — optional <DataTable /> or list
  extra,        // any additional body content
  testId = "tpl-dashboard",
}) {
  return (
    <PageShell testId={testId}>
      {header}
      {kpis && (kpis.items
        ? <KpiBar items={kpis.items} cols={kpis.cols ?? 4} />
        : kpis)}
      {charts}
      {section}
      {table}
      {extra}
    </PageShell>
  );
}
